import {ListItem, ListItemIcon, ListItemText} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {useLocalization} from "@smalox/shared";
import {TextField, useSpringPageable} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {TenantUserSummary, useTenantUserApi} from "../../api";
import {UserIcon} from "../../icons";

export interface UserSelectProps {
	value: TenantUserSummary[];
	onChange: (users: TenantUserSummary[]) => void;
	required?: boolean;
}
export function UserSelect({value, onChange, required}: UserSelectProps) {
	const {t} = useLocalization();
	const {queryUsers} = useTenantUserApi();

	// todo: support for more users
	//  filtering should be server-side
	//  maybe query top users by default
	const pageable = useSpringPageable({pageSize: 1000});

	// todo: display error
	const {loading, error, result} = useAsync(queryUsers, [pageable]);

	// todo: required is currently not validated

	return (
		<Autocomplete
			loading={loading}
			multiple
			options={result?.content ?? []}
			isOptionEqualToValue={(option, value) => option.user.username === value.user.username}
			getOptionLabel={user => user.user.displayName}
			renderInput={(params) => (
				<TextField
					{...params}
					label={t("bookings.users.title")}
					InputLabelProps={{
						required,
					}}
				/>
			)}
			renderOption={(props, user, state) => (
				<ListItem {...props} selected={state.selected}>
					<ListItemIcon>
						<UserIcon />
					</ListItemIcon>
					<ListItemText primary={user.user.displayName} secondary={user.user.email} />
				</ListItem>
			)}
			onChange={(_, value) => onChange(value)}
			value={value}
			fullWidth
		/>
	);
}
